const equipmentProfile = {
  area: "Área",
  backbtn: "Atrás",
  chooseADateRange: "Escoge un rango de fechas",
  comment: "Comentario",
  createdBy: "Creado Por",
  customer: "Cliente",
  dateCreated: "Fecha de Creación",
  deleteEquipment: "Eliminar activo",
  equipment: "Activo",
  equipmentStatus: "Condición mecánica del activo",
  equipmentTag: "TAG del Activo",
  equipmentType: "Tipo de Activo",
  goBack: "Atrás",
  hazardous: "Clasificación de area peligrosa",
  manufacturer: "Fabricante",
  mechanical: "Código de Sello Mecanico",
  model: "Modelo",
  nocomment: "Ninguno",
  product: "Producto",
  pumpHousing: "Carcasa de la bomba",
  responsible: "Selecciona responsable del activo",
  sealTypes: "Tipo de sello mecánico",
  snackText: "Su archivo ha sido descargado en la carpeta de descargas",
  typeContract: "Tipo de Contrato",
  updatebtn: "ACTUALIZAR ACTIVO"
};
export default equipmentProfile;
